import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import WelcomePage from '../views/WelcomeView.vue';
import { trackRouter } from "vue-gtag-next";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("../views/LoadingView.vue"),
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: WelcomePage,
    meta: {
      title: 'AVE VPN — лучший VPN в России',
      metaTags: [
        {
          name: 'description',
          content: 'Лучший VPN с высокой скоростью, стабильной работой и бесплатным пробным периодом. Подключайся к AVE VPN уже сейчас!'
        },
        {
          property: 'og:title',
          content: 'AVE VPN — лучший VPN сервис'
        },
        {
          property: 'og:description',
          content: 'Премиальный VPN с бесплатным пробным периодом и высокой скоростью соединения.'
        },
        {
          property: 'og:image',
          content: 'https://avevpn.com/ave-og.png'
        }
      ]
    }
  },
  {
    path: "/tech",
    name: "tech",
    component: () => import("../views/TechWorksView.vue"),
  },
  {
    path: "/InstructionView",
    name: "InstructionView",
    component: () => import("../views/InstructionView.vue"),
  },
  {
    path: "/deposit",
    name: "deposit",
    component: () => import("../views/DepositView.vue"),
  },
  {
    path: "/payment-history",
    name: "payment-history",
    component: () => import("../views/PayHistoryView.vue"),
  },
  {
    path: "/referal",
    name: "referal",
    component: () => import("../views/ReferalsView.vue"),
  },
  {
    path: "/buyVPN",
    name: "buyVPN",
    component: () => import("../views/BuyVpnView.vue"),
  },
  // ✅ Рулетка призов (без нижнего навбара — его нет в pagesWithNav в App.vue)
  {
    path: "/roulette",
    name: "roulette",
    component: () => import("../views/RouletteView.vue"),
  },
  {
    path: "/installVPN",
    name: "installVPN",
    component: () => import("../views/InstallView.vue"),
  },
  {
    path: "/installVPNFree",
    name: "installVPNFree",
    component: () => import("../views/InstallViewFree.vue"),
  },
  {
    path: "/ChooseOSView",
    name: "ChooseOSView",
    component: () => import("../views/manual/ChooseOSView.vue"),
  },
  {
    path: "/InstallAppIOS",
    name: "InstallAppIOS",
    component: () => import("../views/manual/ios/InstallAppIOS.vue"),
  },
  {
    path: "/FoXrayPrivacyView",
    name: "FoXrayPrivacyView",
    component: () => import("../views/manual/ios/foXRay/FoXrayPrivacyView.vue"),
  },
  {
    path: "/CopyFreeLinkView",
    name: "CopyFreeLinkView",
    component: () => import("../views/manual/ios/foXRay/CopyIOSLinkView.vue"),
  },
  {
    path: "/FoXrayAddCfgView",
    name: "FoXrayAddCfgView",
    component: () => import("../views/manual/ios/foXRay/FoXrayAddCfgView.vue"),
  },
  {
    path: "/OnOffFoxRay",
    name: "OnOffFoxRay",
    component: () => import("../views/manual/ios/foXRay/OnOffFoxRay.vue"),
  },
  {
    path: "/CopyLinkIosHiddify",
    name: "CopyLinkIosHiddify",
    component: () => import("../views/manual/ios/hiddify/3_CopyIOSLinkView.vue"),
  },
  {
    path: "/HiddifyPerm",
    name: "HiddifyPerm",
    component: () => import("../views/manual/ios/hiddify/2_HiddifyPerm.vue"),
  },
  {
    path: "/InstallAppMacOS",
    name: "InstallAppMacOS",
    component: () => import("../views/manual/MacOs/1_InstallAppMacOS.vue"),
  },
  {
    path: "/FoXrayPrivacyViewMacOS",
    name: "FoXrayPrivacyViewMacOS",
    component: () => import("../views/manual/MacOs/2_FoXrayPrivacyView.vue"),
  },
  {
    path: "/CopyFreeLinkViewMacOS",
    name: "CopyFreeLinkViewMacOS",
    component: () => import("../views/manual/MacOs/3_CopyMacOSLinkView.vue"),
  },
  {
    path: "/FoXrayAddCfgViewMacOS",
    name: "FoXrayAddCfgViewMacOS",
    component: () => import("../views/manual/MacOs/4_FoXrayAddCfgView.vue"),
  },
  {
    path: "/OnOffFoxRayMacOS",
    name: "OnOffFoxRayMacOS",
    component: () => import("../views/manual/MacOs/5_OnOffFoxRay.vue"),
  },
  {
    path: "/InstallAppWin",
    name: "InstallAppWin",
    component: () => import("../views/manual/win/InstallAppWin.vue"),
  },
  {
    path: "/NecoInstallView",
    name: "NecoInstallView",
    component: () => import("../views/manual/win/NekoInstallView.vue"),
  },
  {
    path: "/NekorayAddCfgView",
    name: "NekorayAddCfgView",
    component: () => import("../views/manual/win/NekorayAddCfgView.vue"),
  },
  {
    path: "/CopyWINLinkView",
    name: "CopyWINLinkView",
    component: () => import("../views/manual/win/CopyWINLinkView.vue"),
  },
  {
    path: "/OnOffNeko",
    name: "OnOffNeko",
    component: () => import("../views/manual/win/OnOffNeko.vue"),
  },
  {
    path: "/InstallAppAndroid",
    name: "InstallAppAndroid",
    component: () => import("../views/manual/android/InstallAppAndroid.vue"),
  },
  {
    path: "/CopyAndroidLinkView",
    name: "CopyAndroidLinkView",
    component: () => import("../views/manual/android/CopyAndroidLinkView.vue"),
  },
  {
    path: "/HiddifyAddCfgView",
    name: "HiddifyAddCfgView",
    component: () => import("../views/manual/android/HiddifyAddCfgView.vue"),
  },
  {
    path: "/OnOffHiddify",
    name: "OnOffHiddify",
    component: () => import("../views/manual/android/OnOffHiddify.vue"),
  },
  {
    path: "/v2rayInstallIos",
    name: "v2rayInstallIos",
    component: () => import("../views/manual/ios/happ/InstallHapp.vue"),
  },
  {
    path: "/v2rayErrorIos",
    name: "v2rayErrorIos",
    component: () => import("../views/manual/ios/v2ray/ErrorInst.vue"),
  },
  {
    path: "/v2rayInstallAndroid",
    name: "v2rayInstallAndroid",
    component: () => import("../views/manual/android/happ/InstallHapp.vue"),
  },
  {
    path: "/v2rayErrorAndroid",
    name: "v2rayErrorAndroid",
    component: () => import("../views/manual/android/v2ray/ErrorInst.vue"),
  },
  {
    path: "/hiddifyInstallWin",
    name: "hiddifyInstallWin",
    component: () => import("../views/manual/win/hiddify/HiddifyInstView.vue"),
  },
  {
    path: "/hiddifyConfWin",
    name: "hiddifyConfWin",
    component: () => import("../views/manual/win/hiddify/HiddifyConfig.vue"),
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/FAQView.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/ProfileView.vue"),
  },
  {
    path: "/connection",
    name: "Connection",
    component: () => import("../views/ConnectionView.vue"),
  },
  {
    path: "/tasks",
    name: "tasks",
    component: () => import("../views/TasksView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
trackRouter(router);

// 🧠 Добавляем SEO: title и meta теги
router.afterEach((to) => {
  // Устанавливаем title
  if (to.meta?.title) {
    document.title = to.meta.title as string;
  }

  // Удаляем предыдущие meta теги
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).forEach(el => {
    el.parentNode?.removeChild(el);
  });

  // Добавляем новые
  if (to.meta?.metaTags) {
    (to.meta.metaTags as Array<any>).forEach(tagDef => {
      const tag = document.createElement('meta');
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute('data-vue-router-controlled', '');
      document.head.appendChild(tag);
    });
  }
});

export default router;
